/* import __COLOCATED_TEMPLATE__ from './user-summary-topic.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./user-summary-topic.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  tagName: "li"
}));